import { type FC } from "react";

import lensPreviewArBarSvg from "@app-assets/svg/lens-preview-ar-bar.svg";

import { ARBarPreview } from "./LensCtaMediaPreview.styles";

export const LensCtaMediaPreviewBar: FC = () => <ARBarPreview src={lensPreviewArBarSvg} alt="Lens Preview AR bar" />;
